import React, { Fragment, useEffect } from 'react';
import Markdown from 'markdown-to-jsx';
import Faq from '../../Components/Faq/Faq';
const FaqsHome = ({ groups, title, stillHaveQuestionsTitle, getInTouchDescription }) => {
    const faqs = groups.flatMap((group, groupIndex) => {
        return group.faqs.map((faq, faqIndex) => {
            return Object.assign(Object.assign({}, faq), { groupTitle: group.title, groupId: `faq-group-${groupIndex + 1}`, isFirstInGroup: faqIndex === 0 });
        });
    });
    const midpoint = Math.ceil(faqs.length / 2);
    const columns = [
        { key: 'left', faqs: faqs.slice(0, midpoint) },
        { key: 'right', faqs: faqs.slice(midpoint) }
    ];
    useEffect(() => {
        const openFaqFromHash = () => {
            const id = window.location.hash.replace('#', '');
            if (!id) {
                return;
            }
            const element = document.getElementById(id);
            if (element instanceof HTMLDetailsElement) {
                element.open = true;
                element.scrollIntoView({ block: 'start' });
            }
        };
        openFaqFromHash();
        window.addEventListener('hashchange', openFaqFromHash);
        return () => {
            window.removeEventListener('hashchange', openFaqFromHash);
        };
    }, []);
    return (React.createElement("div", { className: "flex w-full flex-col gap-12" },
        React.createElement("h2", { className: "text-center font-semibold text-gray-800 text-3xl leading-[120%] md:leading-12" }, title),
        React.createElement("div", { className: "grid grid-cols-1 items-start gap-3 md:grid-cols-2 md:gap-x-6" }, columns.map((column) => {
            return (React.createElement("div", { className: "flex flex-col gap-3", key: column.key }, column.faqs.map((faq) => {
                return (React.createElement(Fragment, { key: faq.anchor },
                    faq.isFirstInGroup && (React.createElement("h2", { id: faq.groupId, className: "sr-only" }, faq.groupTitle)),
                    React.createElement(Faq, { question: faq.question, answer: faq.answer, id: faq.anchor, defaultOpen: faq.defaultOpen, compact: true, headingLevel: "h3" })));
            })));
        })),
        React.createElement(Markdown, { className: "text-center text-lg leading-7 text-gray-700 md:text-2xl md:leading-9" }, `${stillHaveQuestionsTitle} ${getInTouchDescription}`)));
};
export default FaqsHome;
